var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platform-squad-wrapper"},[_c('TournamentCardPlatform',{attrs:{"tournament":_vm.tournament,"omit-dot":true}}),_c('TournamentCardSquadSize',{attrs:{"tournament":_vm.tournament}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }